import { useEffect } from 'react';
import { compose } from 'recompose';
import { RouteComponentProps } from 'react-router';
import { connect } from 'react-redux';
import { StoreState } from '@mm/state/store-interfaces';
import { Dispatch } from 'redux';
import promotionsCRUDActions from '@mm/state/actions/PromotionsCRUDActions';
import { Routes } from '../../../routes/top-level-routes';
import { selectActiveCompanyId } from '@mm/state/selectors/viewSelectors';
import { ErrorReportingUtils } from '@mm/plugins';
import { LocalStorageService } from '@mm/utils';
import { routes as authRoutes } from '../../../modules/LoginRouter/routes';

type OuterProps = {};

type InnerProps = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps> &
  RouteComponentProps;

type Props = OuterProps & InnerProps;

export const PROMO_CODE_KEY = 'promoCode';

const RedeemPromoCode = (props: Props) => {
  const { match, session, addPromoToUser, history, location, companyId } =
    props;
  const promoCode = match.params['promoCode'];

  const applyPromoAndRedirect = async () => {
    try {
      await addPromoToUser(companyId, promoCode);
    } catch (error) {
      ErrorReportingUtils.reportError('Redeem Promo Code Error', {
        extraData: { error },
      });
    }

    history.push(Routes.settings.getLink());
  };

  useEffect(() => {
    if (promoCode) {
      if (session) {
        applyPromoAndRedirect();
      } else {
        LocalStorageService.setItem(PROMO_CODE_KEY, promoCode);
        history.push(authRoutes.signup.compile());
      }
    } else {
      ErrorReportingUtils.reportError('Promo Code Missing');
      history.push(Routes.chatbotEditor.getLink());
    }
  }, []);

  return null;
};

const mapStateToProps = (state: StoreState) => ({
  session: state.session.session,
  companyId: selectActiveCompanyId(state),
});

const mapDispatchToProps = (dispatch: Dispatch<StoreState>) => ({
  addPromoToUser: (companyId: number, promoCode: string) =>
    dispatch(promotionsCRUDActions.addPromoToUser(companyId, promoCode)),
});

const enhance = compose<InnerProps, OuterProps>(
  connect(mapStateToProps, mapDispatchToProps),
);

export default enhance(RedeemPromoCode);
